

const YOUTUBE_PLAYLIST_ITEMS_API = 'https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&maxResults=50&playlistId=PLIV3PwFXgZzRkl6n9fw5ytfuMYKiA9CX1&key=AIzaSyB90cIkChMSvgk4amZ41PRR8ZpbGAaT1dU';

export async function getServerSideProps() {
    const res = await fetch(`${YOUTUBE_PLAYLIST_ITEMS_API}`)
    const data = await res.json();
    return {
        props: {
            data
        }
    }
}




